// 虫情
const insectUrl = "/business/jgInsectInfo/";
// 设备
const devcieUrl = "/business/jgCad/";
const api = {
  // 查询智慧虫情历史趋势
  selectInsectImgByList: insectUrl + "selectInsectImgByList",
  // 查询智慧虫情图片历史数据
  selectInsectImgByPage: insectUrl + "selectInsectImgByPage",
  // 绑定设备
  updateJgCad: devcieUrl + "updateJgCad",
  // 获取监控播放地址
  selectCameraDemourl: "/business/jgCameraDemoInfo/selectCameraDemourl",
  // 获取智能设备统计
  selectDeviceOnlineTotal: "/business/jgDeviceStats/selectDeviceOnlineTotal",
  // 获取智能设备信息
  selectDeviceList: "/business/jgDeviceStats/selectDeviceList",
  selectDeviceGroupProjectPage: '/business/jgDeviceStats/selectDeviceGroupProjectPage'
};
export default api;
